



























































































































































































































































import {
  Component, Mixins, Prop, Watch,
} from 'vue-property-decorator';
import PlatformsAndSuppliersMixin from '@/mixins/PlatformsAndSuppliersMixin';
import {
  groupBy, sumBy, meanBy, uniqBy,
} from 'lodash';
import DateRange from '@/components/common/DateRange.vue';
import { accountingSheet } from '@/utils/config';
import Axios from 'axios';
import { TypeExtractionRules } from '@/classes/schema-constructors/types';

@Component({
  components: {
    DateRange,
  },
})
export default class FormationOfAccountingSheets extends Mixins(PlatformsAndSuppliersMixin) {
  @Prop({
    type: String,
    required: false,
    default: 'FormationOfAccountingSheets',
  }) readonly localStoragePrefix!: string;

  dates: string[] = [];

  defaultDates: string[] = [];

  openPanels: number[] = [];

  formation = false;

  groupOperationsByClients: any = null;

  isOperationsLoading = false;

  clientsIsLoading = false;

  settingDefaultsInProgress = false;

  selectedSupplier: string[] = [];

  defaultSupplier: string[] = [];

  selectedClient: string[] = [];

  defaultClient: string[] = [];

  selectedPlatform: any = null;

  defaultPlatform: any = null;

  operations = [];

  clients = [];

  tableHeaders = [
    {
      text: 'Поставщик',
      value: 'supplierName',
    }, {
      text: 'Операция',
      value: 'operationName',
    }, {
      text: 'Центр затрат',
      value: 'costCenter',
    }, {
      text: 'Производительные часы',
      value: 'performanceWatch',
    }, {
      text: 'Непроизводительные часы',
      value: 'unproductiveWatch',
    }, {
      text: 'Стоимость часа',
      value: 'costPerHour',
    }, {
      text: 'Выполненный объем',
      value: 'sumActualSize',
    }, {
      text: 'Стоимость короба',
      value: 'boxCost',
    }, {
      text: 'Производительность %',
      value: 'meanPerformance',
    }, {
      text: 'Качество %',
      value: 'meanQuality',
    }, {
      text: 'Итого',
      value: 'totalAmount',
    },
  ];

  async mounted() {
    this.calculateDefaultDates();
    this.defaultPlatform = this.userPlatforms[0]?.id || '';
  }

  calculateDefaultDates() {
    const dateNow = new Date();
    const dateAgo = new Date();
    dateAgo.setMonth(dateAgo.getMonth() - 1);
    dateAgo.setDate(1);
    this.defaultDates = [dateAgo.toISOString().split('T')[0], dateNow.toISOString().split('T')[0]];
  }

  loadClients(rules?: TypeExtractionRules) {
    return this.loadDataByLike('clients', 'Client', 'Plants', this.selectedPlatform, 'cache-first', rules);
  }

  get listOfSuppliersFromOperations() {
    const result = uniqBy(this.operations, 'application.Supplier.id')
      .map((i: any) => ({
        id: i.application.Supplier.id,
        legal_name: i.application.Supplier.legal_name,
        total: 0,
      }));

    this.operations.forEach((operation: any) => {
      result.forEach((item: any) => {
        if (item.id === operation.application.Supplier.id) {
          item.total += operation.total;
        }
      });
    });

    return result;
  }

  get listOfClientsFromOperations() {
    const result = uniqBy(this.operations, 'application.client.id')
      .map((i: any) => ({
        id: i.application.client.id,
        legal_name: i.application.client.legal_name,
        total: 0,
      }));

    this.operations.forEach((operation: any) => {
      result.forEach((item: any) => {
        if (item.id === operation.application.client.id) {
          item.total += operation.total;
        }
      });
    });

    return result;
  }

  async toShape() {
    this.formation = true;
    const url = accountingSheet.toShapeAccountingSheet;
    const data = {
      dateFrom: this.dates[0],
      dateTo: this.dates[1],
      suppliers: this.listOfSuppliersFromOperations.map((i: any) => i.id),
      clients: this.listOfClientsFromOperations.map((i: any) => i.id),
      platformId: this.selectedPlatform,
    };
    try {
      await Axios.post(url, data);
      await this.loadOperations();
      this.formation = false;
    } catch (e) {
      console.error(e);
      this.formation = false;
    }
  }

  async saveQualityPerformance(key: string) {
    const groupOperations = this.groupOperationsByClients[key];
    if (groupOperations?.length && !this.isOperationsLoading) {
      this.isOperationsLoading = true;
      const operations: any[] = [];
      groupOperations.forEach((groupOperation: any) => {
        if (groupOperation?.ids?.length) {
          const operationsPart: any[] = [];
          groupOperation.ids.forEach((id: number | string) => {
            operationsPart.push({
              id,
              quality: groupOperation.meanQuality,
              performance: groupOperation.meanPerformance,
            });
          });

          if (groupOperation.sumActualSize !== groupOperation.oldSumActualSize) {
            const averageActualSize: number = Math.floor((groupOperation.sumActualSize * 100) / groupOperation.ids.length);
            let remainder: number = (groupOperation.sumActualSize * 100) % groupOperation.ids.length;
            operationsPart.forEach((operation: any) => {
              operation.actual_size = (averageActualSize + (remainder > 0.01 ? 1 : 0)) / 100;
              remainder -= 1;
            });
          }

          operations.push(...operationsPart);
        }
      });
      const url = accountingSheet.bulkQualityPerformance;
      try {
        await Axios.put(url, { operations });
        await this.loadOperations();
      } catch (e) {
        console.error(e);
        this.isOperationsLoading = false;
      }
    }
  }

  async loadOperations() {
    this.isOperationsLoading = true;
    let url = accountingSheet.calculatedOperations;
    url = url.replace('{dateFrom}', this.dates[0]);
    url = url.replace('{dateTo}', this.dates[1]);
    url = url.replace('{supplier}', this.selectedSupplier.join(','));
    url = url.replace('{clientIds}', this.selectedClient.join(','));
    url = url.replace('{platformId}', this.selectedPlatform);
    try {
      const res = await Axios.get(url);
      if (res.data && res.data.length) {
        this.operations = res.data;
        this.groupOperationsByClients = this.groupingOfOperations(this.operations);
        this.setOpenPanels(this.groupOperationsByClients);
      } else {
        this.groupOperationsByClients = null;
        this.operations = [];
      }
      this.isOperationsLoading = false;
    } catch (e) {
      console.error(e);
      this.isOperationsLoading = false;
      this.groupOperationsByClients = null;
      this.operations = [];
    }
  }

  groupingOfOperations(items: any[]) {
    const groupByClients = groupBy(items, 'application.client.legal_name');
    Object.keys(groupByClients).forEach((client) => {
      const groupBySupplier = groupBy(groupByClients[client], 'application.Supplier.id');
      const array: any[] = [];
      Object.keys(groupBySupplier).forEach((supplierId) => {
        const groupByWorkTypeName = groupBy(groupBySupplier[supplierId], 'workType.id');
        Object.keys(groupByWorkTypeName).forEach((operationId) => {
          array.push({
            ids: groupByWorkTypeName[operationId].map((i) => i.id),
            supplierId,
            supplierName: groupByWorkTypeName[operationId][0]?.application?.Supplier?.legal_name || '',
            operationId,
            operationName: groupByWorkTypeName[operationId][0]?.workType?.name || '',
            meanPerformance: meanBy(groupByWorkTypeName[operationId], 'performance').toFixed(2),
            meanQuality: meanBy(groupByWorkTypeName[operationId], 'quality').toFixed(2),
            sumActualSize: sumBy(groupByWorkTypeName[operationId], 'actual_size').toFixed(2),
            oldSumActualSize: sumBy(groupByWorkTypeName[operationId], 'actual_size').toFixed(2),
            sumActualWorkTime: sumBy(groupByWorkTypeName[operationId], 'actual_work_time'),
            performanceWatch: sumBy(groupByWorkTypeName[operationId]
              .filter((i) => i?.workType?.work_billing_type?.code === 'productive'), 'actual_work_time') || '',
            unproductiveWatch: sumBy(groupByWorkTypeName[operationId]
              .filter((i) => i?.workType?.work_billing_type?.code === 'unproductive'), 'actual_work_time') || '',
            costPerHour: groupByWorkTypeName[operationId][0]?.workType?.work_billing_type?.code === 'unproductive'
              ? this.$n(groupByWorkTypeName[operationId][0].rate, 'decimal') : '',
            boxCost: groupByWorkTypeName[operationId][0]?.workType?.work_billing_type?.code === 'productive'
              ? this.$n(groupByWorkTypeName[operationId][0].rate, 'decimal') : '',
            totalAmount: this.$n(sumBy(groupByWorkTypeName[operationId], 'total'), 'decimal'),
            costCenter: groupByWorkTypeName[operationId][0]?.workType?.cost_center?.name || '',
          });
        });
      });
      groupByClients[client] = array;
    });
    return groupByClients;
  }

  async beforeLoadSuppliers() {
    this.selectedSupplier = [];
    this.selectedClient = [];
    await this.loadClients({ maxDepth: 1 });
  }

  async afterLoadSuppliers() {
    this.settingDefaultsInProgress = true;
    this.selectedSupplier = this.suppliers?.length ? this.suppliers.map(({ id }) => id) : [];
    this.selectedClient = this.clients?.length ? this.clients.map(({ id }) => id) : [];
  }

  async afterLoadingPlatforms() {
    if (this.selectedPlatform) {
      this.settingDefaultsInProgress = true;

      this.defaultSupplier = this.suppliers?.length ? this.suppliers.map(({ id }) => id) : [];
      this.selectedSupplier = this.getFromStorage('suppliers')
        .split(',')
        .filter((supplierId) => supplierId.trim() !== '');
      if (this.selectedSupplier?.length === 0) {
        this.selectedSupplier = this.defaultSupplier;
      }

      await this.loadClients({ maxDepth: 1 });
      this.defaultClient = this.clients?.length ? this.clients.map(({ id }) => id) : [];
      this.selectedClient = this.getFromStorage('clients')
        .split(',')
        .filter((clientId) => clientId.trim() !== '');
      if (this.selectedClient?.length === 0) {
        this.selectedClient = this.defaultClient;
      }
    } else {
      await this.loadOperations();
    }
  }

  setOpenPanels(object: any) {
    this.openPanels = Object.keys(object).map((k, i) => i);
  }

  sumTotalAmount(collection: any[]): number {
    return collection
      .map((item) => parseFloat(item.totalAmount.replace(',', '.').replace(/\s/g, '')))
      .reduce((a, b) => a + b, 0);
  }

  @Watch('selectedSupplier')
  async selectedSupplierChanged(value: string) {
    this.setToStorage('suppliers', this.selectedSupplier.join(','));
    if (value?.length && !this.settingDefaultsInProgress) {
      await this.loadOperations();
    }
    this.settingDefaultsInProgress = false;
  }

  @Watch('selectedClient')
  async selectedClientChanged(value: string) {
    this.setToStorage('clients', this.selectedClient.join(','));
    if (value?.length && !this.settingDefaultsInProgress) {
      await this.loadOperations();
    }
    this.settingDefaultsInProgress = false;
  }

  @Watch('dates')
  async datesChanged(value: string, oldValue: string | undefined) {
    if (value?.length && oldValue?.length) {
      await this.loadOperations();
    }
  }

  filtersChanged(): boolean {
    return this.selectedPlatform !== this.defaultPlatform
      || this.selectedSupplier.length !== this.defaultSupplier.length
      || this.selectedSupplier.some((supplerId, index) => supplerId !== this.defaultSupplier[index])
      || this.selectedClient.length !== this.defaultClient.length
      || this.selectedClient.some((clientId, index) => clientId !== this.defaultClient[index])
      || this.dates.length !== 2
      || this.dates[0] !== this.defaultDates[0]
      || this.dates[1] !== this.defaultDates[1];
  }

  clearFilters() {
    this.selectedPlatform = this.defaultPlatform;
    this.selectedSupplier = this.defaultSupplier;
    this.selectedClient = this.defaultClient;
    this.$bus.$emit('clear-filters');
  }
}
